import React, { createContext, useContext, useState } from 'react';

const ValueContext = createContext();
const SetterContext = createContext();

export const FormValuesProvider = ({ children }) => {
  const [value, setValue] = useState({});

  return (
    <ValueContext.Provider value={value}>
      <SetterContext.Provider value={setValue}>
        {children}
      </SetterContext.Provider>
    </ValueContext.Provider>
  );
};

export const useFormValues = () => useContext(ValueContext);
export const useSetFormValues = () => useContext(SetterContext);
